import "./matchTeam.sass";

export default function MatchTeam({ groupId, matchId, name, flag, score, scoreField, clase, onChangeScore, locked }) {
  const flagClass = `bandera-${flag}`;

  return (
    <div className={`MatchTeamSide side-${clase}`}>
      {clase === 'home' ?
        <>
          <span className="TeamName">{name}</span>
          {flag && <div className={flagClass}></div>}
          <input
            className={`ScoreInput ${locked ? "is-locked" : ""}`}
            type="number"
            min="0"
            max="99"
            value={score ?? ""}
            onChange={(e) => !locked && onChangeScore?.(groupId, matchId, scoreField, e.target.value)}
            inputMode="numeric"
            disabled={locked}
            readOnly={locked}
          />
        </> :
        <>
          <input
            className={`ScoreInput ${locked ? "is-locked" : ""}`}
            type="number"
            min="0"
            max="99"
            value={score ?? ""}
            onChange={(e) => !locked && onChangeScore?.(groupId, matchId, scoreField, e.target.value)}
            inputMode="numeric"
            disabled={locked}
            readOnly={locked}
          />
          {flag && <div className={flagClass}></div>}
          <span className="TeamName">{name}</span>

        </>
      }
    </div>
  );
}